import { render } from "./SessionTimeoutControl.vue?vue&type=template&id=72e42344"
import script from "./SessionTimeoutControl.vue?vue&type=script&lang=js"
export * from "./SessionTimeoutControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__